export default __webpack_public_path__ + "static/media/loader.2166d7c0.gif";